export enum MobileDataService {
  BuyPackage = "BUY_PACKAGE",
  TravelSim = "TRAVEL_SIM",
  SimEcommerce = "SIM_ECOMMERCE",
}

export enum MobileDataCategories {
  TravelSim = "SP_travel",
  SimEcommerce = "SP_ecommerce",
}

export enum MobileDataType {
  Combo,
  "Add on",
  Roaming,
}

export enum PriceRange {
  "1.000 đến 30.000" = "1000,30000",
  "30.000 đến 50.000" = "30000,50000",
  "50.000 đến 100.000" = "50000,100000",
  "100.000 đến 300.000" = "100000,300000",
  "300.000 đến 500.000" = "300000,500000",
  "500.000 đến 1.000.000" = "500000,1000000",
  "1.000.000 đến 3.000.000" = "1000000,3000000",
  "3.000.000 đến 5.000.000" = "3000000,5000000",
  "5.000.000 trở lên" = "5000000",
}
